/** Fecha calendario en America/Bogota (YYYY-MM-DD). */
export function fechaEnBogota(d: Date = new Date()): string {
  return d.toLocaleDateString('en-CA', { timeZone: 'America/Bogota' });
}

export function parseFechaBogota(yyyyMmDd: string): Date {
  const parts = yyyyMmDd.split('-').map(Number);
  const y = parts[0] ?? 1970;
  const m = parts[1] ?? 1;
  const day = parts[2] ?? 1;
  return new Date(Date.UTC(y, m - 1, day, 12, 0, 0));
}
